import axios from 'axios';
import _ from 'lodash';
import {
  createWarehouseLocality,
  getWarehouseLocality,
  updateWarehouseLocality,
} from '../../../../../api/warehouse/warehouse';
import {
  WarehouseLocality,
  WarehouseLocalitySave,
} from '../../../../../api/warehouse/warehouseApiTypes';
import { Edit } from './kauflandWarehouseState';

function mapRequest(
  marketplaceCode: string,
  warehouseLocality: WarehouseLocality | undefined,
  edit: Edit,
): WarehouseLocalitySave {
  const { isDefault, ...address } = edit;

  return {
    ..._.omitBy(address, _.isEmpty),
    code: warehouseLocality?.code,
    isDefault: isDefault ?? false,
    marketplaceCode,
  };
}

export async function loadWarehouseLocality(id: number): Promise<WarehouseLocality | undefined> {
  try {
    return await getWarehouseLocality(id);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status !== 404) {
      throw error;
    }

    return undefined;
  }
}

export async function saveWarehouseLocality(
  marketplaceCode: string,
  warehouseLocality: WarehouseLocality | undefined,
  edit: Edit,
): Promise<number | null> {
  const request = mapRequest(marketplaceCode, warehouseLocality, edit);
  const id = warehouseLocality?.id;

  if (!id) {
    return createWarehouseLocality(request);
  }

  return updateWarehouseLocality(id, request);
}
